import { SxStyles } from 'src/types/theme';
import { COLORS } from 'src/theme/palette';

const styles: SxStyles = {
  wrapper: {
    display: 'flex',
    flexFlow: 'row',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    marginBottom: '10px',
    '&:hover button': {
      visibility: 'visible',
      opacity: '1',
    },
  },
  description: {
    padding: '14px 23px',
    border: `1px solid ${COLORS.orange9}`,
    backgroundColor: COLORS.orange11,
    borderRadius: '8px',
    cursor: 'pointer',
    width: `90%`,
    flexGrow: 1,
    textAlign: 'justify',
    overflowWrap: 'break-word',
  },
  list: {
    margin: '12px 0',
    padding: '0 0 0 20px',
    listStyle: 'unset',
    listStyleType: 'disc',
  },
  listItem: {
    display: 'list-item',
    padding: '0',
  },
  buttons: {
    width: `42px`,
    marginLeft: '8px',
  },
  button: {
    marginBottom: '6px',
    visibility: 'hidden',
    opacity: '0',
    transition: 'all .3s ease',
    borderRadius: '6px',
    padding: '7px',
    border: `1px solid ${COLORS.black20}`,
    '& > svg': {
      fill: COLORS.black80,
    },
  },
};

export default styles;
